(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    document.documentElement.classList.remove('js');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  if (window.lenis) {
    window.lenis.on('scroll', ScrollTrigger.update);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 767px)').matches;
  if (reduce || mobile) {
    gsap.set('[data-reveal], [data-reveal-stagger] > *', { autoAlpha: 1, y: 0 });
    return;
  }

  gsap.utils.toArray('[data-reveal]').forEach(function (el) {
    gsap.from(el, {
      autoAlpha: 0,
      y: 28,
      duration: 0.55,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        once: true,
      },
    });
  });

  gsap.utils.toArray('[data-reveal-stagger]').forEach(function (group) {
    gsap.from(group.children, {
      autoAlpha: 0,
      y: 20,
      duration: 0.5,
      stagger: 0.08,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: group,
        start: 'top 88%',
        once: true,
      },
    });
  });

  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });
})();
